// 오른쪽 사이드바
// width : 기본 680px, 커스텀 width props 사용
import React from 'react';

import styles from './styles/side-bar-right.module.css';

export default function SideBarRight({ header, content, width }) {
    return (
        <div className={styles.wrapper} style={{ width }}>
            {header && <div className={styles.header}>{header}</div>}
            <div className={styles.content}>{content}</div>
        </div>
    );
}
